import { useEffect } from 'react';
import { useGallery, usePage } from 'app/hooks';

// This function aim to reduce complexity
const updateMetaTag = (metaTag, updateMetaTagValue) => {
  if (metaTag && updateMetaTagValue) {
    metaTag.setAttribute('content', updateMetaTagValue);
  }
};

export default () => {
  const gallery = useGallery();
  const page = usePage();

  useEffect(() => {
    if (page.isInitializedOrLoaded()) {
      const title = document.querySelector('title');

      if (title && gallery.pageMetaData?.title) {
        title.textContent = gallery.pageMetaData.title;
      }

      updateMetaTag(
        document.querySelector('meta[name="description"]'),
        gallery.pageMetaData?.description
      );

      updateMetaTag(
        document.querySelector('meta[property="og:image"]'),
        gallery.pageMetaData?.heroImage
      );

      updateMetaTag(
        document.querySelector('meta[property="og:title"]'),
        gallery.pageMetaData?.title
      );

      updateMetaTag(
        document.querySelector('meta[property="og:description"]'),
        gallery.pageMetaData?.description
      );

      updateMetaTag(
        document.querySelector('meta[name="twitter:title"]'),
        gallery.pageMetaData?.title
      );

      updateMetaTag(
        document.querySelector('meta[name="twitter:image"]'),
        gallery.pageMetaData?.heroImage
      );
    }
  }, [page.status]);
};
